{
  "settings.title": "Inställningar",
  "settings.workshop": "Verkstad",
  "settings.save": "Spara ändringar",
  "settings.saving": "Sparar …",
  "settings.saved": "Sparat",
  "settings.discard": "Ångra ändringar",
  "settings.unsaved": "Du har ändringar som inte är sparade.",
  "settings.leave_warning": "Du har osparade ändringar. Vill du lämna sidan ändå?",
  "settings.error": "Det gick inte att spara. Försök igen.",
  "settings.retry": "Försök igen",
  "settings.load_error": "Vi kunde inte hämta inställningarna.",
  "settings.cancel": "Avbryt",
  "settings.remove": "Ta bort",
  "settings.add": "Lägg till",
  "settings.nav.hours": "Öppettider",
  "settings.nav.staff": "Personal & resurser",
  "settings.nav.services": "Tjänster & priser",
  "settings.nav.rules": "Bokningsregler",
  "settings.nav.reminders": "Påminnelser",
  "settings.nav.mobile": "Mobil verksamhet",
  "settings.nav.profile": "Profil",
  "settings.nav.calendar": "Kalendersynk",
  "settings.calendar.heading": "Kalendersynk",
  "settings.calendar.body": "Koppla Google Kalender så syns ColorGlo-jobben där personalen redan tittar. Bokningar fungerar som vanligt även om Google ligger nere.",
  "settings.calendar.unavailable": "Google Kalender är inte påslaget i den här miljön. Hör av dig till support.",
  "settings.calendar.connections": "Kopplade konton",
  "settings.calendar.connect": "Anslut Google Kalender",
  "settings.calendar.reconnect": "Återanslut",
  "settings.calendar.disconnect": "Koppla från",
  "settings.calendar.sync_now": "Synka nu",
  "settings.calendar.syncing": "Synkar …",
  "settings.calendar.queued": "Synkningen är köad.",
  "settings.calendar.status.connected": "Ansluten",
  "settings.calendar.status.degraded": "Behöver återanslutas",
  "settings.calendar.status.disconnected": "Inte ansluten",
  "settings.calendar.last_synced": "Senast synkad {when}",
  "settings.calendar.never_synced": "Aldrig synkad",
  "settings.calendar.pending.one": "{count} jobb väntar på att skickas",
  "settings.calendar.pending.other": "{count} jobb väntar på att skickas",
  "settings.calendar.disconnect_confirm": "Koppla från {account}? ColorGlos bokningar tas bort ur kalendern.",
  "settings.calendar.disconnect_keep": "Koppla från och behåll händelserna",
  "settings.calendar.disconnected": "Kopplingen är borttagen.",
  "settings.calendar.privacy.heading": "Vad som syns i kalendern",
  "settings.calendar.privacy.body": "Gäller alla kopplade konton på verkstaden. En teknikers telefon visar kalendern på låsskärmen, så välj inte mer än ni behöver.",
  "settings.calendar.privacy.full": "Fullständiga uppgifter",
  "settings.calendar.privacy.full_hint": "Tjänst, kundens förnamn, telefon och adress.",
  "settings.calendar.privacy.initials": "Bara initialer",
  "settings.calendar.privacy.initials_hint": "Tjänst och kundens initialer. Ingen telefon.",
  "settings.calendar.privacy.busy": "Bara ”Upptagen”",
  "settings.calendar.privacy.busy_hint": "Ingenting om jobbet syns.",
  "settings.calendar.privacy.saved": "Sparat. Kommande bokningar skrivs om.",
  "settings.calendar.feeds.heading": "Prenumerationslänkar (ICS)",
  "settings.calendar.feeds.body": "Skrivskyddade länkar att prenumerera på i Apple Kalender eller Outlook. Länken visas en gång — kopiera den nu.",
  "settings.calendar.feeds.create": "Skapa länk",
  "settings.calendar.feeds.rotate": "Byt länk",
  "settings.calendar.feeds.revoke": "Återkalla",
  "settings.calendar.feeds.whole_franchise": "Hela verkstaden",
  "settings.calendar.feeds.copy": "Kopiera",
  "settings.calendar.feeds.copied": "Länken är kopierad.",
  "settings.calendar.feeds.once": "Detta är enda gången länken visas. Sparar du den inte får du skapa en ny.",
  "settings.calendar.feeds.never_used": "Aldrig hämtad",
  "settings.calendar.feeds.last_used": "Hämtad {when}",
  "settings.calendar.feeds.none": "Inga länkar ännu.",
  "settings.hours.heading": "Öppettider",
  "settings.hours.body": "Tiderna här styr när kunder kan boka. Personal som följer verkstadens tider får dem direkt.",
  "settings.hours.closed": "Stängt",
  "settings.hours.open": "Öppet",
  "settings.hours.from": "Från",
  "settings.hours.to": "Till",
  "settings.hours.add_break": "Lägg till rast",
  "settings.hours.break_hint": "Två rader samma dag betyder att ni har stängt däremellan.",
  "settings.hours.overlap": "Tiderna på samma dag överlappar varandra.",
  "settings.hours.order": "Sluttiden måste vara efter starttiden.",
  "settings.hours.holidays": "Röda dagar",
  "settings.hours.holidays_body": "Kryssa i de dagar ni håller stängt. Kunder kan då inte boka den dagen.",
  "settings.hours.special": "Särskilda dagar",
  "settings.hours.special_body": "Extra öppet eller tidig stängning en enskild dag.",
  "settings.hours.special_empty": "Inga särskilda dagar inlagda.",
  "settings.hours.special_kind": "Vad gäller?",
  "settings.hours.special_closed": "Stängt hela dagen",
  "settings.hours.special_extra": "Extra öppet",
  "settings.hours.special_date": "Datum",
  "settings.hours.special_reason": "Anledning",
  "settings.staff.heading": "Personal & resurser",
  "settings.staff.body": "Alla som utför jobb, och de bilar och platser som bokas. Varje rad blir en egen kolumn i kalendern.",
  "settings.staff.name": "Namn",
  "settings.staff.type": "Typ",
  "settings.staff.type.staff": "Person",
  "settings.staff.type.van": "Bil",
  "settings.staff.type.bay": "Plats",
  "settings.staff.color": "Färg i kalendern",
  "settings.staff.bookable": "Går att boka",
  "settings.staff.active": "Aktiv",
  "settings.staff.inherits": "Följer verkstadens öppettider",
  "settings.staff.own_hours": "Egna arbetstider",
  "settings.staff.skills": "Utför dessa tjänster",
  "settings.staff.skills_empty": "Ingen tjänst vald — då kan ingen bokning läggas här.",
  "settings.staff.add": "Lägg till person eller resurs",
  "settings.staff.added": "Tillagd.",
  "settings.staff.remove": "Ta bort",
  "settings.staff.remove_heading": "Ta bort {name}?",
  "settings.staff.remove_body.one": "{count} kommande bokning är tilldelad {name}.",
  "settings.staff.remove_body.other": "{count} kommande bokningar är tilldelade {name}.",
  "settings.staff.remove_none": "{name} har inga kommande bokningar.",
  "settings.staff.remove_assign_body": "Välj vem som tar varje bokning. Den som är upptagen vid tiden kan inte väljas.",
  "settings.staff.remove_assign_all": "Ge alla tider personen är ledig till",
  "settings.staff.remove_free_count": "ledig för {free} av {count}",
  "settings.staff.remove_pick": "Välj person",
  "settings.staff.remove_option_free": "Ledig",
  "settings.staff.remove_option_busy": "Upptagen",
  "settings.staff.remove_option_hours": "Utanför arbetstid",
  "settings.staff.remove_option_skill": "Utför inte tjänsten",
  "settings.staff.remove_progress": "{done} av {count} bokningar har fått en ny person.",
  "settings.staff.remove_no_candidates": "Det finns ingen annan som kan ta bokningarna. Lägg till en person först och flytta sedan bokningarna.",
  "settings.staff.remove_conflict": "{name} hann bli bokad under den tiden. Välj någon annan för den här bokningen.",
  "settings.staff.remove_new_booking": "En ny bokning har kommit in under tiden. Välj vem som tar den också.",
  "settings.staff.remove_no_customer": "Kund saknas",
  "settings.staff.remove_confirm": "Ta bort och flytta bokningarna",
  "settings.staff.remove_confirm_empty": "Ta bort",
  "settings.staff.deactivate": "Avaktivera i stället",
  "settings.staff.deactivate_hint": "En avaktiverad person försvinner ur kalendern men behåller sin historik.",
  "settings.staff.deactivated_notice": "{name} har avaktiverats så att bokningshistoriken finns kvar.",
  "settings.staff.reactivate": "Aktivera igen",
  "settings.staff.invite": "Bjud in med e-post",
  "settings.staff.invite_email": "E-postadress",
  "settings.staff.invite_send": "Skapa inbjudan",
  "settings.staff.invite_pending": "Väntar på svar",
  "settings.staff.invite_link": "Skicka den här länken till {email}:",
  "settings.staff.invite_copy": "Kopiera länken",
  "settings.staff.invite_copied": "Länken är kopierad.",
  "settings.staff.invite_revoke": "Dra tillbaka",
  "settings.staff.invite_expires": "Länken gäller till {date}.",
  "settings.services.heading": "Tjänster & priser",
  "settings.services.body": "Nätverkets tjänster. Slå på det ni utför och ändra tid eller pris där ni skiljer er.",
  "settings.services.enabled": "Erbjuds här",
  "settings.services.inherited": "Nätverkets värde: {value}",
  "settings.services.duration": "Tid",
  "settings.services.price": "Pris",
  "settings.services.buffer_before": "Förberedelse före",
  "settings.services.buffer_after": "Efterarbete efter",
  "settings.services.max_per_day": "Max per dag",
  "settings.services.max_per_day_hint": "0 betyder ingen gräns.",
  "settings.services.assessment": "Kräver besiktning",
  "settings.services.assessment_hint": "Kunden bokar en kort besiktning och får en offert efteråt — inget pris visas.",
  "settings.services.reset": "Använd nätverkets värde",
  "settings.services.minutes": "minuter",
  "settings.services.disable_heading": "Sluta erbjuda {name}?",
  "settings.services.disable_body.one": "Tjänsten försvinner ur bokningen på webben direkt. {count} kommande bokning påverkas inte.",
  "settings.services.disable_body.other": "Tjänsten försvinner ur bokningen på webben direkt. {count} kommande bokningar påverkas inte.",
  "settings.services.disable_confirm": "Sluta erbjuda",
  "settings.rules.heading": "Bokningsregler",
  "settings.rules.body": "Ramarna för vad en kund kan boka själv på webben.",
  "settings.rules.min_notice": "Hur sent kan kunder boka?",
  "settings.rules.min_notice_hint": "Tider som ligger närmare än så här går inte att boka på webben. Ni kan alltid boka in dem själva.",
  "settings.rules.max_horizon": "Hur långt fram kan kunder boka?",
  "settings.rules.max_horizon_hint": "Kalendern på webben visar inte längre fram än så här.",
  "settings.rules.granularity": "Hur tätt ligger tiderna?",
  "settings.rules.granularity_hint": "Kunden får välja på jämna intervall — 30 minuter är vanligast.",
  "settings.rules.auto_confirm": "Bekräfta bokningar automatiskt",
  "settings.rules.auto_confirm_hint": "Kunden får en bekräftelse direkt. Är det avstängt får kunden veta att ni återkommer.",
  "settings.rules.same_day": "Tillåt bokning samma dag",
  "settings.rules.cancellation": "Hur sent får kunden avboka själv?",
  "settings.rules.cancellation_hint": "Senare än så här får kunden ringa er i stället. Avbokning ska aldrig vara svårare än bokning.",
  "settings.rules.max_per_day": "Max bokningar per dag",
  "settings.rules.max_per_day_hint": "0 betyder ingen gräns.",
  "settings.rules.hours": "timmar",
  "settings.rules.days": "dagar",
  "settings.rules.minutes": "minuter",
  "settings.reminders.heading": "Påminnelser",
  "settings.reminders.body": "Ett mejl per rad. Läs raden högt — står det rätt, gör den rätt.",
  "settings.reminders.sentence": "Skicka {channel} {offset} {event}",
  "settings.reminders.channel.email": "e-post",
  "settings.reminders.offset.before": "{value} innan",
  "settings.reminders.offset.after": "{value} efter",
  "settings.reminders.offset.immediately": "direkt",
  "settings.reminders.event.booked": "bokad tid",
  "settings.reminders.event.confirmed": "bekräftad bokning",
  "settings.reminders.event.rescheduled": "flyttad bokning",
  "settings.reminders.event.cancelled": "avbokning",
  "settings.reminders.event.no_show": "utebliven kund",
  "settings.reminders.event.completed": "avslutat jobb",
  "settings.reminders.template": "Mejl",
  "settings.reminders.template_name.booking_confirmed": "Bokningsbekräftelse",
  "settings.reminders.template_name.reminder": "Påminnelse",
  "settings.reminders.template_name.rescheduled": "Flyttad bokning",
  "settings.reminders.template_name.cancelled": "Avbokning",
  "settings.reminders.template_name.assessment_booked": "Bokad besiktning",
  "settings.reminders.template_name.job_completed": "Jobbet är klart",
  "settings.reminders.template_name.review_request": "Be om omdöme",
  "settings.reminders.template_name.no_show_followup": "Uteblivet besök",
  "settings.reminders.template_name.waitlist_slot_open": "Ledig tid från väntelistan",
  "settings.reminders.when": "När",
  "settings.reminders.when_before": "Innan tiden",
  "settings.reminders.when_after": "Efter händelsen",
  "settings.reminders.amount": "Hur långt",
  "settings.reminders.unit.hours": "timmar",
  "settings.reminders.unit.days": "dagar",
  "settings.reminders.service": "Gäller tjänst",
  "settings.reminders.service_all": "Alla tjänster",
  "settings.reminders.active": "Påslagen",
  "settings.reminders.add": "Lägg till påminnelse",
  "settings.reminders.empty": "Inga påminnelser än. Lägg till en så hör ni av er i tid.",
  "settings.reminders.remove_heading": "Ta bort påminnelsen?",
  "settings.reminders.remove_body": "Kommande utskick från den här regeln ställs in. Redan skickade mejl finns kvar i loggen.",
  "settings.reminders.move_up": "Flytta upp",
  "settings.reminders.move_down": "Flytta ned",
  "settings.reminders.preview": "Förhandsvisning",
  "settings.reminders.preview_locale": "Språk",
  "settings.reminders.preview_subject": "Ämne",
  "settings.reminders.test": "Skicka test till mig",
  "settings.reminders.test_sent": "Testmejlet är skickat till dig.",
  "settings.reminders.test_redirected": "Testmejlet skickades till utvecklingsadressen.",
  "settings.mobile.heading": "Mobil verksamhet",
  "settings.mobile.body": "Var ni utgår ifrån, hur långt ni åker och vad resan kostar.",
  "settings.mobile.base": "Utgångspunkt",
  "settings.mobile.base_hint": "Dagen börjar och slutar här. Restiden räknas från den här adressen.",
  "settings.mobile.address": "Adress",
  "settings.mobile.postcode": "Postnummer",
  "settings.mobile.city": "Ort",
  "settings.mobile.latitude": "Latitud",
  "settings.mobile.longitude": "Longitud",
  "settings.mobile.radius": "Hur långt åker ni?",
  "settings.mobile.radius_hint": "Kunder utanför området får inte boka er på webben.",
  "settings.mobile.km": "km",
  "settings.mobile.speed": "Snitthastighet",
  "settings.mobile.speed_unit": "km/h",
  "settings.mobile.speed_hint": "Används för att räkna restid mellan jobb. 50 km/h passar de flesta.",
  "settings.mobile.setup": "Tid för lastning och rigg",
  "settings.mobile.surcharge": "Tillägg per kilometer",
  "settings.mobile.postcodes": "Postnummer ni åker till",
  "settings.mobile.postcodes_hint": "Ett postnummer per rad. Lämna tomt om ni hellre använder området ovan.",
  "settings.mobile.polygon_note": "Ett ritat område finns sedan tidigare och används också.",
  "settings.profile.heading": "Profil",
  "settings.profile.body": "Det här ser kunderna om er — i bokningen och i mejlen.",
  "settings.profile.display_name": "Namn utåt",
  "settings.profile.phone": "Telefon",
  "settings.profile.email": "E-post kunder svarar till",
  "settings.profile.email_hint": "Svar på bokningsmejl hamnar här.",
  "settings.profile.address": "Gatuadress",
  "settings.profile.address2": "Adressrad 2",
  "settings.profile.description": "Om verkstaden",
  "settings.profile.description_hint": "Två meningar räcker. Skriv som ni pratar.",
  "settings.profile.logo": "Egen logotyp",
  "settings.profile.logo_hint": "Adress till en bild som börjar med https.",
  "settings.profile.review_url": "Länk för omdömen",
  "settings.profile.photos": "Bilder",
  "settings.profile.photos_hint": "En bildadress per rad, alla med https.",
  "settings.reports.title": "Rapporter",
  "settings.reports.body": "Få dina siffror mejlade automatiskt. Rapporten innehåller bara den här verkstadens siffror.",
  "settings.reports.add": "Lägg till rapport",
  "settings.reports.edit": "Ändra rapport",
  "settings.reports.empty": "Inga rapporter är schemalagda än.",
  "settings.reports.recipient": "Mottagare",
  "settings.reports.recipient_help": "Bara personer som arbetar här kan väljas.",
  "settings.reports.period": "Hur ofta",
  "settings.reports.period.weekly": "Varje vecka",
  "settings.reports.period.monthly": "Varje månad",
  "settings.reports.weekday": "Dag",
  "settings.reports.day_of_month": "Datum i månaden",
  "settings.reports.hour": "Tid",
  "settings.reports.metrics": "Siffror att ta med",
  "settings.reports.include_csv": "Bifoga kalkylblad (CSV)",
  "settings.reports.active": "Aktiv",
  "settings.reports.sentence.weekly": "Skicka veckorapport varje {weekday} {hour} till {recipient}",
  "settings.reports.sentence.monthly": "Skicka månadsrapport den {day}:e varje månad {hour} till {recipient}",
  "settings.reports.paused": "Pausad",
  "settings.reports.send_test": "Skicka test till mig",
  "settings.reports.test_sent": "Testrapporten är på väg till {email}.",
  "settings.reports.saved": "Rapporten är sparad.",
  "settings.reports.deleted": "Rapporten är borttagen.",
  "settings.reports.delete": "Ta bort",
  "settings.reports.last_sent": "Senast skickad för perioden som slutade {date}",
  "settings.reports.never_sent": "Har inte skickats än",
  "settings.reports.history": "Skickade rapporter",
  "settings.reports.history_empty": "Inget har skickats än.",
  "settings.reports.status.pending": "Köad",
  "settings.reports.status.sent": "Skickad",
  "settings.reports.status.failed": "Misslyckades",
  "settings.reports.status.skipped": "Överhoppad",
  "settings.reports.status.cancelled": "Avbruten",
  "settings.reports.no_metrics": "Välj minst en siffra.",
  "settings.reports.duplicate": "Den här personen får redan en rapport med samma intervall.",
  "weekday.1": "måndag",
  "weekday.2": "tisdag",
  "weekday.3": "onsdag",
  "weekday.4": "torsdag",
  "weekday.5": "fredag",
  "weekday.6": "lördag",
  "weekday.7": "söndag",
  "settings.nav.reports": "Rapporter",
  "settings.nav.integrations": "Integrationer",
  "settings.messaging.heading": "Meddelanden till kunder",
  "settings.messaging.body": "Välj hur dina kunder får påminnelser utöver e-post. Kunder som inte har lämnat ett mobilnummer får bara e-post.",
  "settings.messaging.none": "HQ har inte slagit på någon SMS- eller WhatsApp-leverantör ännu.",
  "settings.messaging.one_at_a_time": "En åt gången. Byter du leverantör skickas kommande påminnelser via den nya.",
  "settings.messaging.sender": "Avsändarnamn",
  "settings.messaging.sender.hint": "Det namn kunden ser, till exempel CGAvesta. 3–11 bokstäver eller siffror, utan mellanslag. Lämna tomt för ColorGlo HQ:s standardnamn.",
  "settings.messaging.sender.invalid": "Använd 3–11 bokstäver eller siffror, utan mellanslag, och börja med en bokstav.",
  "settings.messaging.active.hint": "När det är avstängt får kunderna bara e-post.",
  "settings.integrations.title": "Integrationer",
  "settings.integrations.by": "Av {vendor}",
  "settings.integrations.steps": "{count} steg",
  "settings.integrations.view": "Visa instruktioner",
  "settings.integrations.close": "Stäng",
  "settings.integrations.crumb": "Integrationer / {name}",
  "settings.integrations.how": "Så fungerar det",
  "settings.integrations.setup": "Så kommer du igång",
  "settings.integrations.configure": "Anslut",
  "settings.integrations.verify.body": "Kontrollerar nycklarna mot leverantören utan att skicka något.",
  "settings.integrations.channel.email": "E-post",
  "settings.integrations.channel.sms": "SMS",
  "settings.integrations.channel.whatsapp": "WhatsApp",
  "settings.integrations.status.always_on": "Alltid på",
  "settings.integrations.status.not_connected": "Ej ansluten",
  "settings.integrations.status.unverified": "Ej verifierad",
  "settings.integrations.status.error": "Anslutningsfel",
  "settings.integrations.status.verified": "Verifierad",
  "settings.integrations.status.unavailable": "Ej påslagen av HQ",
  "settings.integrations.status.available": "Tillgänglig",
  "settings.integrations.status.active": "Aktiv",
  "settings.integrations.how.email": "Bokningsbekräftelser och påminnelser skickas alltid med e-post till kunder som har lämnat en e-postadress. Det gäller alla verkstäder, oavsett vad som är valt för SMS eller WhatsApp.",
  "settings.integrations.how.sms": "Påminnelser skickas som SMS till kunder som har lämnat ett mobilnummer. Kunder utan mobilnummer får bara e-post. Varje SMS kostar en liten summa som ColorGlo HQ betalar.",
  "settings.integrations.how.whatsapp": "Påminnelser skickas som WhatsApp-meddelande till kunder som har tackat ja till det. Kunder utan WhatsApp får bara e-post.",
  "settings.integrations.email_resend.name": "E-post",
  "settings.integrations.email_resend.description": "E-post till kunderna skickas från ColorGlo HQ:s konto hos Resend. Alltid påslaget.",
  "settings.integrations.email_resend.hq.step.1": "Domänen send.colorglo.se är verifierad hos Resend.",
  "settings.integrations.email_resend.hq.step.2": "API-nyckeln sätts av utvecklarna i serverns miljö, inte här.",
  "settings.integrations.email_resend.hq.step.3": "Inget mer behövs. Alla verkstäder skickar e-post automatiskt.",
  "settings.integrations.email_resend.owner.step.1": "E-post är alltid påslaget för din verkstad.",
  "settings.integrations.email_resend.owner.step.2": "Kunderna får bokningsbekräftelse och påminnelser till sin e-postadress.",
  "settings.integrations.email_resend.owner.step.3": "Du ändrar när påminnelserna skickas under Påminnelser.",
  "settings.integrations.sms_elks46.name": "46elks",
  "settings.integrations.sms_elks46.description": "Svensk SMS-leverantör med data inom EU. Betalas per skickat SMS.",
  "settings.integrations.sms_elks46.hq.step.1": "Skapa ett konto på 46elks.se och fyll på saldo.",
  "settings.integrations.sms_elks46.hq.step.2": "Öppna Account i 46elks dashboard och kopiera API-användarnamn och API-lösenord.",
  "settings.integrations.sms_elks46.hq.step.3": "Klistra in nycklarna nedan och ange ett standardavsändarnamn, till exempel ColorGlo.",
  "settings.integrations.sms_elks46.hq.step.4": "Testa anslutningen och slå sedan på 46elks för verkstäderna.",
  "settings.integrations.sms_elks46.owner.step.1": "Slå på 46elks här. Det ersätter en annan SMS- eller WhatsApp-leverantör om du hade valt en.",
  "settings.integrations.sms_elks46.owner.step.2": "Ange ett eget avsändarnamn, till exempel CGAvesta, eller lämna tomt för ColorGlos namn.",
  "settings.integrations.sms_elks46.owner.step.3": "Kunder som lämnar mobilnummer får påminnelser via SMS. Övriga får e-post.",
  "settings.integrations.sms_prelude.name": "Prelude SMS",
  "settings.integrations.sms_prelude.description": "SMS via Prelude, som byter operatör automatiskt för hög leveransgrad.",
  "settings.integrations.sms_prelude.hq.step.1": "Logga in på Prelude dashboard och skapa en API-nyckel under API Keys.",
  "settings.integrations.sms_prelude.hq.step.2": "Be Prelude skapa en testmall utan variabler, och mallarna för bokningsbekräftelse och påminnelse på svenska, norska och engelska.",
  "settings.integrations.sms_prelude.hq.step.3": "Klistra in API-nyckeln och testmallens ID nedan. Avsändarnamnet måste vara godkänt i Prelude.",
  "settings.integrations.sms_prelude.hq.step.4": "Testa anslutningen, skicka ett test till dig själv och slå sedan på Prelude för verkstäderna. Testmeddelandet är den riktiga kontrollen: anslutningstestet kan godkänna en nyckel som ändå inte får skicka.",
  "settings.integrations.sms_prelude.owner.step.1": "Slå på Prelude SMS här. Det ersätter en annan SMS- eller WhatsApp-leverantör om du hade valt en.",
  "settings.integrations.sms_prelude.owner.step.2": "Ange ett eget avsändarnamn eller lämna tomt för ColorGlos namn. HQ behöver ha godkänt namnet hos Prelude.",
  "settings.integrations.sms_prelude.owner.step.3": "Kunder som lämnar mobilnummer får påminnelser via SMS. Övriga får e-post.",
  "settings.integrations.whatsapp_meta.name": "WhatsApp",
  "settings.integrations.whatsapp_meta.description": "WhatsApp direkt från Meta. Kunden måste ha WhatsApp och ha tackat ja till meddelanden.",
  "settings.integrations.whatsapp_meta.hq.step.1": "Verifiera ColorGlo som företag i Meta Business Manager och lägg till ett telefonnummer under WhatsApp.",
  "settings.integrations.whatsapp_meta.hq.step.2": "Skapa en systemanvändare med behörighet whatsapp_business_messaging och generera en permanent token.",
  "settings.integrations.whatsapp_meta.hq.step.3": "Klistra in token och telefonnummer-ID nedan. hello_world används som testmeddelande.",
  "settings.integrations.whatsapp_meta.hq.step.4": "Testa anslutningen, skicka ett test till dig själv och slå sedan på WhatsApp för verkstäderna.",
  "settings.integrations.whatsapp_meta.owner.step.1": "Slå på WhatsApp här. Det ersätter SMS om du hade valt det.",
  "settings.integrations.whatsapp_meta.owner.step.2": "Meddelanden skickas från ColorGlos godkända WhatsApp-nummer. Du behöver inte ange något avsändarnamn.",
  "settings.integrations.whatsapp_meta.owner.step.3": "Kunder som tackar ja får påminnelser i WhatsApp. Övriga får e-post.",
  "settings.integrations.whatsapp_prelude.name": "Prelude WhatsApp",
  "settings.integrations.whatsapp_prelude.description": "WhatsApp via Prelude, med samma konto och mallar som Prelude SMS.",
  "settings.integrations.whatsapp_prelude.hq.step.1": "Logga in på Prelude dashboard och skapa en API-nyckel, eller använd samma som för Prelude SMS.",
  "settings.integrations.whatsapp_prelude.hq.step.2": "Be Prelude koppla ett WhatsApp-nummer och sätta upp mallarna som enbart WhatsApp, så att de inte faller tillbaka till SMS.",
  "settings.integrations.whatsapp_prelude.hq.step.3": "Klistra in API-nyckeln och testmallens ID nedan.",
  "settings.integrations.whatsapp_prelude.hq.step.4": "Testa anslutningen, skicka ett test till dig själv och slå sedan på Prelude WhatsApp för verkstäderna. Testmeddelandet är den riktiga kontrollen: anslutningstestet kan godkänna en nyckel som ändå inte får skicka.",
  "settings.integrations.whatsapp_prelude.owner.step.1": "Slå på Prelude WhatsApp här. Det ersätter SMS om du hade valt det.",
  "settings.integrations.whatsapp_prelude.owner.step.2": "Meddelanden skickas från ColorGlos WhatsApp-nummer hos Prelude. Du behöver inte ange något avsändarnamn.",
  "settings.integrations.whatsapp_prelude.owner.step.3": "Kunder som tackar ja får påminnelser i WhatsApp. Övriga får e-post.",
  "settings.messaging.active_via": "Skicka påminnelser via {provider}",
  "settings.messaging.sender.after_choosing": "Slå på {provider} för att välja avsändarnamn.",
  "settings.messaging.sender.whatsapp": "WhatsApp-meddelanden skickas från ColorGlos godkända nummer, så det finns inget avsändarnamn att välja.",
  "settings.integrations.sms_twilio.name": "Twilio",
  "settings.integrations.sms_twilio.description": "SMS via Twilio, en global leverantör. Betalas per skickat SMS.",
  "settings.integrations.sms_twilio.hq.step.1": "Skapa eller logga in på ett konto på twilio.com och uppgradera det från testläge.",
  "settings.integrations.sms_twilio.hq.step.2": "Kopiera Account SID och Auth Token från startsidan i Twilio Console.",
  "settings.integrations.sms_twilio.hq.step.3": "Klistra in dem nedan och ange en standardavsändare: ett namn som ColorGlo eller ett Twilio-nummer.",
  "settings.integrations.sms_twilio.hq.step.4": "Testa anslutningen, skicka ett test till dig själv och slå sedan på Twilio för verkstäderna.",
  "settings.integrations.sms_twilio.owner.step.1": "Slå på Twilio här. Det ersätter en annan SMS- eller WhatsApp-leverantör om du hade valt en.",
  "settings.integrations.sms_twilio.owner.step.2": "Ange ett eget avsändarnamn, till exempel CGAvesta, eller lämna tomt för ColorGlos namn.",
  "settings.integrations.sms_twilio.owner.step.3": "Kunder som lämnar mobilnummer får påminnelser via SMS. Övriga får e-post.",
  "settings.rules.inspection": "Besiktningstid",
  "settings.rules.inspection_hint": "Hur lång tid varje bokning får. Pris och tid för själva jobbet bestäms med kunden efter besiktningen.",
  "settings.staff.open": "Öppna",
  "settings.staff.back": "Personal & resurser",
  "settings.staff.tab.overview": "Översikt",
  "settings.staff.tab.profile": "Profil",
  "settings.staff.tab.schedule": "Schema",
  "settings.staff.tab.time_off": "Ledighet",
  "settings.staff.tab.activity": "Aktivitet",
  "settings.staff.role.franchise_owner": "Ägare",
  "settings.staff.role.franchise_staff": "Personal",
  "settings.staff.status.active": "Aktiv",
  "settings.staff.status.inactive": "Avaktiverad",
  "settings.staff.no_account": "{name} har ingen inloggning. Bjud in personen med e-post för att ge tillgång.",
  "settings.staff.account.heading": "Inloggning",
  "settings.staff.account.body": "Namnet och e-postadressen personen loggar in med.",
  "settings.staff.account.name": "Namn",
  "settings.staff.account.email": "E-postadress",
  "settings.staff.account.email_hint": "Vi meddelar både den gamla och den nya adressen.",
  "settings.staff.account.phone": "Telefon",
  "settings.staff.account.language": "Språk",
  "settings.staff.account.saved": "Sparat.",
  "settings.staff.account.owner_locked": "Ägarkonton ändras av HQ.",
  "settings.staff.account.shared": "{name} arbetar även på en annan verkstad. E-postadressen och utloggning ändras av HQ.",
  "settings.staff.security.heading": "Säkerhet",
  "settings.staff.security.last_active": "Senast aktiv {when}",
  "settings.staff.security.never": "Har inte loggat in än",
  "settings.staff.security.sessions.one": "Inloggad på {count} enhet",
  "settings.staff.security.sessions.other": "Inloggad på {count} enheter",
  "settings.staff.security.reset": "Skicka länk för nytt lösenord",
  "settings.staff.security.reset_title": "Skicka länk till {email}?",
  "settings.staff.security.reset_body": "Länken gäller i 24 timmar. Det gamla lösenordet fungerar tills ett nytt har valts.",
  "settings.staff.security.reset_send": "Skicka länken",
  "settings.staff.security.reset_sent": "Länken är skickad till {email}.",
  "settings.staff.security.sign_out": "Logga ut från alla enheter",
  "settings.staff.security.sign_out_title": "Logga ut {name} överallt?",
  "settings.staff.security.sign_out_body": "{name} loggas ut på alla enheter och måste logga in igen.",
  "settings.staff.security.sign_out_confirm": "Logga ut",
  "settings.staff.security.signed_out": "{name} är utloggad.",
  "settings.staff.schedule.heading": "Kalender och arbetstider",
  "settings.staff.schedule.body": "Hur {name} syns i kalendern, när hen jobbar och vilka tjänster hen utför.",
  "settings.staff.schedule.calendar_name": "Namn i kalendern",
  "settings.staff.danger.heading": "Avaktivera",
  "settings.staff.danger.body": "{name} försvinner ur kalendern och loggas ut. Inloggningen stängs, Google-kalendern kopplas bort och kalenderflöden slutar fungera. Historiken finns kvar.",
  "settings.staff.danger.deactivate": "Avaktivera {name}",
  "settings.staff.danger.reactivate_body": "{name} är avaktiverad. Aktivera igen för att ge tillbaka kalenderkolumnen och inloggningen.",
  "settings.staff.invite_resend": "Skicka igen",
  "settings.staff.invite_resent": "Inbjudan är skickad igen.",
  "settings.staff.time_off.heading": "Ledighet",
  "settings.staff.time_off.body": "Semester, sjukdom och utbildning. Tiden går inte att boka.",
  "settings.staff.time_off.add": "Lägg till ledighet",
  "settings.staff.time_off.from": "Från",
  "settings.staff.time_off.to": "Till och med",
  "settings.staff.time_off.start": "Starttid",
  "settings.staff.time_off.end": "Sluttid",
  "settings.staff.time_off.reason": "Anteckning",
  "settings.staff.time_off.added": "Ledigheten är sparad.",
  "settings.staff.time_off.removed": "Ledigheten är borttagen.",
  "settings.staff.time_off.upcoming": "Kommande",
  "settings.staff.time_off.past": "Senaste året",
  "settings.staff.time_off.empty": "Ingen ledighet registrerad.",
  "settings.staff.time_off.days.one": "{count} dag",
  "settings.staff.time_off.days.other": "{count} dagar",
  "settings.staff.time_off.training_hint": "Utbildning behöver en start- och sluttid.",
  "settings.staff.time_off.invalid_range": "Slutdatumet ska vara samma dag eller senare, och högst 120 dagar fram.",
  "settings.staff.activity.heading": "Aktivitet",
  "settings.staff.activity.body": "Vad som har ändrats för {name}, och av vem.",
  "settings.staff.activity.empty": "Inget har ändrats än.",
  "settings.staff.activity.via_hq": "via HQ",
  "settings.staff.activity.system": "Systemet",
  "settings.staff.activity.resource_created": "Lades till",
  "settings.staff.activity.resource_updated": "Kalender eller schema ändrades",
  "settings.staff.activity.resource_deactivated": "Avaktiverades",
  "settings.staff.activity.staff_account_updated": "Inloggningsuppgifter ändrades",
  "settings.staff.activity.password_reset_sent": "Fick en länk för nytt lösenord",
  "settings.staff.activity.password_reset_completed": "Valde ett nytt lösenord",
  "settings.staff.activity.staff_signed_out": "Loggades ut från alla enheter",
  "settings.staff.activity.blocker_created": "Ledighet lades till: {kind}, {date}",
  "settings.staff.activity.blocker_deleted": "Ledighet togs bort: {kind}, {date}",
  "settings.staff.activity.other": "Ändring",
  "settings.staff.overview.heading": "Översikt",
  "settings.staff.overview.body": "Hur det har gått för {name}. Bara du som ägare ser siffrorna.",
  "settings.staff.overview.period": "Period",
  "settings.staff.overview.period.30": "Senaste 30 dagarna",
  "settings.staff.overview.period.90": "Senaste 90 dagarna",
  "settings.staff.overview.period.365": "Senaste 12 månaderna",
  "settings.staff.overview.previous": "{value} perioden innan",
  "settings.staff.overview.kpi.jobs_completed": "Utförda jobb",
  "settings.staff.overview.kpi.worked": "Arbetade timmar",
  "settings.staff.overview.kpi.revenue": "Omsättning",
  "settings.staff.overview.kpi.job_value": "Snittvärde per jobb",
  "settings.staff.overview.kpi.utilisation": "Beläggning",
  "settings.staff.overview.kpi.no_show_rate": "Uteblivna",
  "settings.staff.overview.kpi.cancellation_rate": "Avbokade",
  "settings.staff.overview.hours": "{hours} h",
  "settings.staff.overview.hint.utilisation": "Bokad tid delat med arbetstid, samma beräkning som för verkstaden.",
  "settings.staff.overview.time_off": "Ledighet under perioden",
  "settings.staff.overview.days": "{days} dagar",
  "settings.staff.overview.chart.jobs": "Utförda jobb",
  "settings.staff.overview.chart.utilisation": "Beläggning",
  "settings.staff.overview.chart.table": "Visa som tabell",
  "settings.staff.overview.chart.period": "Period",
  "settings.staff.overview.services": "Jobb per tjänst",
  "settings.staff.overview.services.jobs": "Jobb",
  "settings.staff.overview.services.service": "Tjänst",
  "settings.staff.overview.recent": "Senaste jobben",
  "settings.staff.overview.empty": "Inga jobb under perioden."
}
